export const profissional_emulti = {
  nome: 'Profissional da eMulti',
  id_perfil: 15,
  dashboard: [
    {
      link: '',
      titulo: 'Notificação ao usuário',
      icone: false,
      imagem: '',
      svg: '',
      key: 'modal_atencao_notificacoes',
      type: 'modal',
    },
    {
      link: '/vinculo-acompanhamento',
      titulo: 'Vínculo e Acompanhamento',
      icone: false,
      imagem: '',
      svg: 'VinculoAcompanhamento',
      key: 'vinculo_acompanhamento',
      featured: true,
    },
    {
      link: '/indicadores-aps',
      titulo: 'Indicadores APS',
      icone: false,
      imagem: '',
      svg: 'IndicadoresAps',
      key: 'indicadores_aps',
    },
    {
      link: '/gestao-cadastros',
      titulo: 'Gestão cadastros',
      icone: false,
      imagem: '',
      svg: 'GestaoCadastros',
      key: 'gestao_cadastros',
    },
    {
      link: '/oficinas-treinamentos',
      titulo: 'Oficinas Reuniões Treinamentos',
      icone: 'icofont-presentation',
      key: 'oficinas_treinamentos',
      featured: true,
    },
    {
      link: '/upa',
      titulo: 'UPA',
      icone: 'icofont-hospital',
      key: 'upa',
    },
  ],
  administracao: [],
  gestao_cadastros: [
    {
      link: '/gestao-cadastros/cidadao/painel',
      titulo: 'Cidadão',
      icone: 'icofont-users-alt-4',
      key: 'cidadao',
      // openNewTab: true,
      // callback: function (ctx, navigate) {
      //   const parceiro = ctx.$store.state?.infoMunicipio?.parceiro
      //   if (parceiro == null) {
      //     navigate(this.link, this.openNewTab)
      //   } else {
      //     ctx.$toast.error('Não disponível.', '', { position: 'topRight' })
      //   }
      // },
    },
  ],
  visitas_domiciliares: [],
  imunizacao: [],
  vacina_idade_certa: [],
  divergencia_vacinas: [],
  indicadores_aps: [
    {
      link: '/indicadores-aps/emulti',
      titulo: 'eMulti',
      icone: false,
      imagem: '',
      svg: 'eMulti',
      key: 'emulti',
    },
    {
      link: '/indicadores-aps/resultado-municipal',
      titulo: 'Resultado Indicadores Qualidade',
      icone: false,
      imagem: '',
      svg: 'DesempenhoPorEquipe',
      key: 'resultado_municipal_indicadores_aps',
    },
  ],
  pre_natal: [],
  doencas_cronicas: [],
  desempenho_por_equipe: [],
  saude_crianca: [],
  producao: [],
  vinculo_acompanhamento: [
    {
      link: '/vinculo-acompanhamento/diagnostico-situacional',
      titulo: 'Resultado Vínculo Acompanhamento',
      icone: false,
      imagem: '',
      svg: 'DesempenhoPorEquipe',
      key: 'diagnostico_situacional',
    },
    {
      link: '/vinculo-acompanhamento/cadastros-individuais/profissional',
      titulo: 'Cadastro individual',
      icone: false,
      imagem: '',
      svg: 'CadastrosCidadaos',
      key: 'cadastros_cidadaos',
    },
    {
      link: '/vinculo-acompanhamento/acompanhamento',
      titulo: 'Acompanhamento',
      icone: false,
      imagem: '',
      svg: 'Acompanhamento',
      key: 'acompanhamento',
    },
    {
      link: '/vinculo-acompanhamento/avaliacao-atendimentos',
      titulo: 'Avaliação do atendimento',
      icone: 'icofont-heart-eyes',
      key: 'avaliacao_atendimentos',
    },
    {
      link: '/vinculo-acompanhamento/agenda-por-profissional/profissional',
      titulo: 'Agendamentos',
      icone: 'icofont-ui-calendar',
      key: 'agenda_por_profissional',
    },
    {
      link: '/atendimentos-pessoa',
      titulo: 'Atendimentos pessoa',
      icone: false,
      imagem: '',
      svg: 'Acompanhamento',
      key: 'atendimentos_pessoa',
      ajudaKey: 'vinculo_acompanhamento_atendimentos_pessoa',
    },
  ],
  bpa_e_ras: [],
  saude_bucal: [],
  indicadores_esb: [],
  esf_eap: [],
  emulti: [
    {
      link: '/indicadores-aps/emulti/media-atendimentos-por-pessoa',
      titulo: 'Pessoas atendidas',
      icone: false,
      imagem: '',
      svg: 'PessoasAtendidas',
      key: 'media_atendimentos_por_pessoa_emulti',
    },
    {
      link: '/indicadores-aps/emulti/acoes-interprofissionais',
      titulo: 'Ações interprofissionais',
      icone: false,
      imagem: '',
      svg: 'AcoesInterprofissionais',
      key: 'acoes_interprofissionais',
      ribbon: {
        enabled: true,
        text: 'eMulti',
      },
    },
  ],
  oficinas_treinamentos: [
    {
      link: '/oficinas-treinamentos-participante',
      titulo: 'Participante',
      icone: 'icofont-user',
      key: 'oficinas_treinamentos_participante',
    },
    {
      link: '/oficinas-treinamentos-certificados',
      titulo: 'Meus Certificados',
      icone: 'icofont-certificate',
      key: 'oficinas_treinamentos_certificados',
    },
  ],
  upa: [
    {
      link: '/atendimentos-pessoa',
      titulo: 'Atendimentos pessoa',
      icone: false,
      imagem: '',
      svg: 'Acompanhamento',
      key: 'atendimentos_pessoa',
      ajudaKey: 'upa_atendimentos_pessoa',
    },
  ],
  administracao_importar_dados: [],
  caps: [],
}
